import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Badge } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { useNoticeCanonicalLinks } from '../hooks/useCanonicalOpportunities';
import { useNoticeSourceCoverage } from '../hooks/useNoticeCoverage';
import { coverageStateStyle } from './NoticeCoverage';
/** Most severe first: the badge reports the worst state among a Notice's sources. */ const SEVERITY = [
    'failed',
    'unavailable',
    'partial',
    'stale',
    'unknown',
    'no_results'
];
/** Roll source states up to one: all-current is 'current'; otherwise the worst; none is 'unknown'. */ export function rollUpCoverageState(states) {
    if (states.length === 0) return 'unknown';
    if (states.every((s)=>coverageStateStyle(s).complete)) return 'current';
    const rank = (s)=>{
        const i = SEVERITY.indexOf(s);
        return i === -1 ? SEVERITY.indexOf('unknown') : i;
    };
    const worst = states.reduce((w, s)=>rank(s) < rank(w) ? s : w);
    return SEVERITY.includes(worst) ? worst : 'unknown';
}
function CoverageState({ state }) {
    const style = coverageStateStyle(state);
    return /*#__PURE__*/ _jsx(Badge, {
        variant: "outline",
        className: `text-xs ${style.className}`,
        "data-testid": Testids.opportunities.cardCoverage,
        "data-state": state,
        "data-complete": style.complete,
        children: style.label
    });
}
function LinkedCoverage({ opportunityId }) {
    const { data: rows } = useNoticeSourceCoverage(opportunityId);
    if (!rows) return null;
    return /*#__PURE__*/ _jsx(CoverageState, {
        state: rollUpCoverageState(rows.map((r)=>r.state))
    });
}
/**
 * Source coverage for a result card, reusing the detail drawer's hooks and
 * style table (SAD-466). Rendered only for the inspected Notice so the list
 * does not fan out one coverage request per card.
 */ export function CardCoverage({ noticeId }) {
    const { linked, isLoading } = useNoticeCanonicalLinks(noticeId);
    if (isLoading) return null;
    if (linked.length === 0) return /*#__PURE__*/ _jsx(CoverageState, {
        state: "unknown"
    });
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: linked.map((l)=>/*#__PURE__*/ _jsx(LinkedCoverage, {
                opportunityId: l.opportunityId
            }, l.opportunityId))
    });
}
